import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as styles from './FBBody.scss';

var FBBody = /*#__PURE__*/function (_Component) {
  _inherits(FBBody, _Component);

  var _super = _createSuper(FBBody);

  function FBBody() {
    var _this;

    _classCallCheck(this, FBBody);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderMedia", function (media) {
      if (media.length > 1) {// console.log('multiple images');
      } else if (media.length) {// console.log('one image');
      } else {// console.log('no image');
        }

      return media.map(function (url, idx) {
        var styleObj = {
          backgroundImage: "url(".concat(url, ")")
        };
        var classColSize = 12;

        if (media.length === 4) {
          classColSize = 6;
          styleObj.paddingBottom = '50%';
        } else if (media.length === 2) {
          classColSize = 12;
          styleObj.paddingBottom = '50%';
        } else if (media.length === 3) {
          if (idx === 0 || idx === 1) {
            classColSize = 6;
          } else {
            classColSize = 12;
          }

          styleObj.paddingBottom = '50%';
        }

        return /*#__PURE__*/React.createElement("div", {
          key: idx,
          className: "col-xs-".concat(classColSize, " ").concat(styles.imageContainer),
          style: styleObj
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderLink", function (link) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          border: '1px solid rgb(219, 219, 219)',
          textAlign: 'left'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, link.image ? {
          backgroundImage: "url(\"".concat(link.image, "\"), url(\"https://s3.amazonaws.com/likeabucket/user_upload/3/BylCxqFhN.jpeg\")")
        } : {}), {}, {
          paddingBottom: '50%',
          backgroundPosition: 'center center',
          backgroundSize: 'cover',
          borderBottom: '1px solid rgb(219, 219, 219)'
        })
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 5
        }
      }, /*#__PURE__*/React.createElement("h4", {
        className: styles.linkHeader
      }, link.title), /*#__PURE__*/React.createElement("p", {
        style: {
          fontSize: '0.8em'
        }
      }, link.description), /*#__PURE__*/React.createElement("small", {
        style: {
          color: 'rgb(166, 166, 166)',
          fontSize: '0.7em'
        }
      })));
    });

    return _this;
  }

  _createClass(FBBody, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          message = _this$props.message,
          media = _this$props.media,
          link = _this$props.link;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.wrap
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.message,
        style: media.length || !!link || message.length > 280 ? {
          fontSize: 14
        } : {
          fontSize: 24
        }
      }, message), media && media.length > 0 && /*#__PURE__*/React.createElement("div", null, this.renderMedia(media)), link && /*#__PURE__*/React.createElement("div", {
        className: styles.imageWrap
      }, this.renderLink(link)));
    }
  }]);

  return FBBody;
}(Component);

export default FBBody;